var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkSlim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(-873.000000, -477.000000)",
    stroke: "#263238",
    strokeWidth: 2,
    className: "toggle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(522.000000, 236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Searchbar-Copy-2",
    transform: "translate(0.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Checkmark",
    points: "333 20 325 28 321 24"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkSlim);
export default __webpack_public_path__ + "static/media/checkmark-slim.5fa777ad59908cd5d54537f68833a4a8.svg";
export { ForwardRef as ReactComponent };